import { useEffect, useState } from 'react';
import type { TintaDaPecaDto } from '@pieltec/contracts';
import { Button } from '../../../components/ui/button';
import { LookupCombobox } from '../../../components/ui/lookup-combobox';
import { definirTintaDaPeca } from '../../../lib/roteiros/roteiros-api';
import { avisosTintaDaPeca, ENDPOINT_TINTAS_ELEGIVEIS, textoTintaDaPeca } from '../../../lib/roteiros/tinta-da-peca';

export function TintaDaPecaBloco({ materialId, tintaDaPeca, tipoDaPeca, podeGerenciar, onAlterada }: {
  readonly materialId: string;
  readonly tintaDaPeca: TintaDaPecaDto | null;
  readonly tipoDaPeca: string | null;
  readonly podeGerenciar: boolean;
  readonly onAlterada: () => void;
}) {
  const [selecionada, setSelecionada] = useState(tintaDaPeca?.tinta?.materialId ?? '');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const [sucesso, setSucesso] = useState(false);
  useEffect(() => setSelecionada(tintaDaPeca?.tinta?.materialId ?? ''), [tintaDaPeca]);
  const salvar = async (tintaMaterialId: string | null): Promise<void> => {
    setSalvando(true);
    setErro(null);
    setSucesso(false);
    try {
      await definirTintaDaPeca(materialId, tintaMaterialId);
      setSucesso(true);
      onAlterada();
    } catch (falha) {
      setErro(falha instanceof Error ? falha.message : 'Não foi possível trocar a tinta da peça. Tente novamente.');
    } finally {
      setSalvando(false);
    }
  };
  const regraPorCorJaEscolhida = tintaDaPeca?.origem === 'PCP' && tintaDaPeca.tinta === null;
  return (
    <div role="group" aria-label="Tinta da peça" className="flex flex-col gap-2 rounded-md border p-4">
      <p className="text-sm font-semibold">{textoTintaDaPeca(tintaDaPeca)}</p>
      {tintaDaPeca?.trechoDescricao ? <p className="text-xs text-muted-foreground">Descrição do CargaMáquina: {tintaDaPeca.trechoDescricao}</p> : null}
      {avisosTintaDaPeca(tintaDaPeca, tipoDaPeca).map((aviso) => <p key={aviso} className="text-xs text-muted-foreground">{aviso}</p>)}
      {podeGerenciar ? (
        <div className="flex flex-col gap-2">
          <LookupCombobox id="tinta-da-peca-busca" endpoint={ENDPOINT_TINTAS_ELEGIVEIS} label="Tinta da peça" value={selecionada} onChange={setSelecionada} />
          <div className="flex flex-wrap gap-2">
            <Button type="button" disabled={selecionada === '' || salvando} onClick={() => void salvar(selecionada)}>Salvar tinta</Button>
            {!regraPorCorJaEscolhida ? <Button type="button" variant="outline" disabled={salvando} onClick={() => void salvar(null)}>Usar a regra por cor</Button> : null}
          </div>
        </div>
      ) : null}
      {sucesso ? <p role="status" className="text-sm text-muted-foreground">Tinta da peça salva. O consumo previsto foi recalculado.</p> : null}
      {erro ? <p role="alert" className="text-sm text-destructive">{erro}</p> : null}
    </div>
  );
}
